import { type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Loader2 } from 'lucide-react'
import { ComingSoonPage } from '@/shared/components/ui/coming-soon-page'
import { useOrgTicketScope } from './hooks/useOrgTicketScope'

/**
 * Gate de la sección de tickets por ALCANCE (goal
 * portal-tickets-alcance-por-membresia): sustituye al gating por rol
 * (`tickets:read`, exclusivo del ORG_OWNER). La visibilidad la decide el
 * server (query orgTicketScope, resuelta contra Zeus + Identity): cualquier
 * usuario con organización o negocios entra; sin alcance —o si la query
 * falla— se muestra el fallback. El gate DURO sigue viviendo en
 * tickets-server: esto solo controla qué UI se pinta.
 */
export function TicketScopeGate({ children }: { children: ReactNode }) {
  const { t } = useTranslation()
  const { hasScope, loading } = useOrgTicketScope()

  if (loading) {
    return (
      <div className="flex items-center justify-center gap-2 py-24 text-sm text-ink-muted">
        <Loader2 className="size-4 animate-spin" />
        {t('tickets.scope.checking')}
      </div>
    )
  }

  if (!hasScope) {
    return (
      <ComingSoonPage
        title={t('tickets.scope.deniedTitle')}
        subtitle={t('tickets.scope.deniedSubtitle')}
        tag="403"
      />
    )
  }

  return <>{children}</>
}
